/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconStar = createReactComponent("star", "IconStar", [
  [
    "path",
    {
      d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z",
      key: "svg-0"
    }
  ]
]);

export { IconStar as default };
//# sourceMappingURL=IconStar.js.map
